/**
 * CORE-528 — куда ведёт превью-ссылка на эфир.
 *
 * Ссылка `/live/:id?preview=<token>` раздаётся как приглашение в ко-хосты, и
 * до сих пор она вела в GuestRoomScreen кого угодно — в том числе человека,
 * который открыл её первым в жизни и не авторизован. А GuestRoomScreen это
 * поверхность ПУБЛИКАТОРА: она безусловно запрашивает камеру и микрофон и
 * публикует их в эфир. Неавторизованный гость получал системный запрос
 * доступа к камере вместо того, чтобы просто посмотреть эфир.
 *
 * QA переписал контракт (07.08): неавторизованный гость входит только
 * слушателем, без publisher-прав и без запроса устройств. Владелец выбрал
 * вариант A — слушательский путь эфира (subscriber-токен, именованный ростер
 * с анонимными слушателями, счётчик) делает бэкенд в рамках этого же тикета.
 *
 * Пока того контракта нет, ЕДИНСТВЕННОЕ честное поведение для анонима —
 * не пускать его на поверхность публикатора вовсе: анонс эфира он видит,
 * камеру у него никто не просит, а «Присоединиться» уводит в авторизацию
 * (LiveDetailScreen уже гейтит это через showAuthCTA). Превью-токен при этом
 * остаётся в адресе, а returnTo у CTA — это pathname + search, поэтому после
 * входа человек возвращается на ту же ссылку уже авторизованным и попадает
 * в комнату ко-хоста. Ничего доделывать для возврата не нужно.
 *
 * Ростер и счётчик слушателей (AC 3, 5-9) этой развилкой НЕ закрываются —
 * они ждут бэкенда. Здесь закрываются AC 1, 2, 4, 10, 11.
 */

export type BroadcastGuestEntry =
    /** Комната ко-хоста: публикуем камеру и микрофон. Только для авторизованных. */
    | 'cohost_room'
    /** Публичный анонс эфира: смотрим, устройства не трогаем. */
    | 'announcement';

export function resolveBroadcastGuestEntry(opts: {
    previewToken: string | null | undefined;
    isAuthenticated: boolean;
}): BroadcastGuestEntry {
    if (!opts.previewToken) return 'announcement';
    // Роль решает авторизация, а НЕ роль из токена: бэкенд по превью-токену
    // до сих пор выдаёт host кому угодно, и полагаться на неё здесь значит
    // снова открыть анониму публикатора.
    return opts.isAuthenticated ? 'cohost_room' : 'announcement';
}
